import { memo } from "react";
import { cn } from "@/lib/utils";

/**
 * MiniLoader - Compact gradient spinner for thumbnails and inline use
 * Uses Berry → Cobalt gradient to match brand colors
 */
export const MiniLoader = memo(function MiniLoader({
  size = 24,
  className,
}: {
  /** Spinner diameter in pixels (default: 24) */
  size?: number;
  className?: string;
}) {
  const strokeWidth = Math.max(2, size / 12);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={cn("animate-spin", className)}
      style={{ animationDuration: "1s" }}
    >
      <defs>
        <linearGradient
          id="mini-loader-gradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
        >
          {/* Berry */}
          <stop offset="0%" stopColor="var(--color-primitive-pink-500)" />
          {/* Cobalt (Bible Blue) */}
          <stop offset="100%" stopColor="var(--color-primitive-blue-500)" />
        </linearGradient>
      </defs>
      <circle
        cx="12"
        cy="12"
        r={10 - strokeWidth / 2}
        stroke="url(#mini-loader-gradient)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray="45 15"
        fill="none"
      />
    </svg>
  );
});

export default MiniLoader;
